var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container import-file-page" },
    [
      _vm.step !== "done"
        ? [
            _c("div", { staticClass: "upload-layout" }, [
              _c("section", { staticClass: "upload-panel partition-panel" }, [
                _c("div", { staticClass: "partition-layout" }, [
                  _c("div", { staticClass: "partition-block" }, [
                    _c("div", { staticClass: "section-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("zoneImportFile.section.partitionType"))
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "partition-type-row" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "partition-radio-group",
                            model: {
                              value: _vm.partitionType,
                              callback: function ($$v) {
                                _vm.partitionType = $$v
                              },
                              expression: "partitionType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "zoneImportFile.partitionType.byPostCode"
                                  )
                                )
                              ),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("zoneImportFile.partitionType.byCity")
                                )
                              ),
                            ]),
                            _c("el-radio", { attrs: { label: "3" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "zoneImportFile.partitionType.byCountry"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm.isPostCodePartition
                          ? _c(
                              "el-radio-group",
                              {
                                staticClass: "post-code-mode-group",
                                model: {
                                  value: _vm.postCodeMode,
                                  callback: function ($$v) {
                                    _vm.postCodeMode = $$v
                                  },
                                  expression: "postCodeMode",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "normal" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "zoneImportFile.postCodeMode.normal"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "combination" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "zoneImportFile.postCodeMode.combination"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "partition-block" },
                    [
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("zoneImportFile.section.duplicate"))
                        ),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "partition-radio-group",
                          model: {
                            value: _vm.importType,
                            callback: function ($$v) {
                              _vm.importType = $$v
                            },
                            expression: "importType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "zoneImportFile.importType.clearAndImport"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "section",
                { staticClass: "upload-panel instruction-panel" },
                [
                  _c("div", { staticClass: "instruction-main" }, [
                    _vm._m(0),
                    _c("div", { staticClass: "instruction-content" }, [
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("zoneImportFile.section.instructions"))
                        ),
                      ]),
                      _c("div", { staticClass: "import-instructions" }, [
                        _c("p", [
                          _c("i", {
                            staticClass: "el-icon-success success-icon",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "zoneImportFile.instruction.downloadFirst"
                                )
                              )
                          ),
                        ]),
                        _c("p", [
                          _c("i", {
                            staticClass: "el-icon-success success-icon",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("zoneImportFile.instruction.fileSupport")
                              )
                          ),
                        ]),
                        _c("p", [
                          _c("i", {
                            staticClass: "el-icon-success success-icon",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "zoneImportFile.instruction.autoValidate"
                                )
                              )
                          ),
                        ]),
                        _c("p", { staticClass: "warning-line" }, [
                          _c("i", {
                            staticClass: "el-icon-warning warning-icon",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "zoneImportFile.instruction.duplicateWarning"
                                )
                              )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "download-template-btn",
                      attrs: {
                        type: "primary",
                        plain: "",
                        size: "small",
                        icon: "el-icon-download",
                      },
                      on: { click: _vm.downloadTemplate },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("zoneImportFile.button.downloadTemplate"))
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "section",
                { staticClass: "upload-panel file-panel" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.$t("zoneImportFile.section.uploadFile"))),
                  ]),
                  _c(
                    "el-upload",
                    {
                      ref: "elUpload",
                      attrs: {
                        drag: "",
                        action: "",
                        "auto-upload": false,
                        "on-change": _vm.handleFileChange,
                        "on-exceed": _vm.handleExceed,
                        limit: 1,
                        accept: ".xlsx,.xls",
                        "show-file-list": false,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-drag-area" },
                        [
                          _c("i", {
                            staticClass: "el-icon-upload upload-icon",
                          }),
                          _c("div", { staticClass: "upload-text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("zoneImportFile.upload.dragText"))
                            ),
                          ]),
                          _c("div", { staticClass: "upload-sub-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("zoneImportFile.upload.clickToChoose")
                              )
                            ),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-choose-file",
                              attrs: { type: "primary", size: "small" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("zoneImportFile.button.chooseFile")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.uploadedFiles.length > 0
                    ? _c(
                        "div",
                        { staticClass: "uploaded-files-wrap" },
                        _vm._l(_vm.uploadedFiles, function (file, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "uploaded-file-item" },
                            [
                              _c("div", { staticClass: "file-left" }, [
                                _vm._m(1, true),
                                _c("div", { staticClass: "file-info" }, [
                                  _c("div", { staticClass: "file-name" }, [
                                    _vm._v(_vm._s(file.name)),
                                  ]),
                                  _c("div", { staticClass: "file-meta" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.formatFileSize(file.size))
                                      ),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "file-meta-dot" },
                                      [_vm._v("•")]
                                    ),
                                    _c("span", { staticClass: "file-date" }, [
                                      _vm._v(_vm._s(file.date)),
                                    ]),
                                  ]),
                                ]),
                              ]),
                              _c("i", {
                                staticClass: "el-icon-delete delete-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeFile(index)
                                  },
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c(
              "el-card",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.validating,
                    expression: "validating",
                  },
                ],
                staticClass: "result-card",
                attrs: { shadow: "never" },
              },
              [
                _c("div", { staticClass: "result-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("zoneImportFile.section.validateResult"))
                  ),
                ]),
                _c("div", { staticClass: "result-stats" }, [
                  _c("span", { staticClass: "stat-item stat-total" }, [
                    _c("span", { staticClass: "stat-dot" }),
                    _vm._v(" " + _vm._s(_vm.$t("zoneImportFile.stats.total"))),
                    _c("strong", [_vm._v(_vm._s(_vm.validateResult.total))]),
                  ]),
                  _c("span", { staticClass: "stat-item stat-pass" }, [
                    _c("span", { staticClass: "stat-dot" }),
                    _vm._v(" " + _vm._s(_vm.$t("zoneImportFile.stats.passed"))),
                    _c("strong", [_vm._v(_vm._s(_vm.validateResult.passed))]),
                  ]),
                  _c("span", { staticClass: "stat-item stat-fail" }, [
                    _c("span", { staticClass: "stat-dot" }),
                    _vm._v(" " + _vm._s(_vm.$t("zoneImportFile.stats.failed"))),
                    _c("strong", [_vm._v(_vm._s(_vm.validateResult.failed))]),
                  ]),
                ]),
                _c("div", { staticClass: "result-progress-segmented" }, [
                  _vm.validateResult.passRate > 0
                    ? _c("div", {
                        staticClass: "progress-segment progress-pass",
                        style: { width: _vm.validateResult.passRate + "%" },
                      })
                    : _vm._e(),
                  _vm.validateResult.failed > 0
                    ? _c("div", {
                        staticClass: "progress-segment progress-fail",
                        style: {
                          width:
                            (_vm.validateResult.total > 0
                              ? Math.round(
                                  (_vm.validateResult.failed /
                                    _vm.validateResult.total) *
                                    100
                                )
                              : 0) + "%",
                        },
                      })
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "result-bottom" },
                  [
                    _c("p", { staticClass: "result-note" }, [
                      _vm._v(_vm._s(_vm.resultNote)),
                    ]),
                    _vm.canDownloadErrorReport
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              plain: "",
                              size: "small",
                              icon: "el-icon-download",
                            },
                            on: { click: _vm.downloadErrorReport },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "zoneImportFile.button.downloadErrorReport"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "action-footer" },
              [
                _c("el-button", { on: { click: _vm.goBack } }, [
                  _vm._v(_vm._s(_vm.$t("zoneImportFile.button.back"))),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.importing,
                      disabled: !_vm.canStartImport || _vm.validating,
                    },
                    on: { click: _vm.startImport },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            _vm.importing
                              ? "zoneImportFile.button.importing"
                              : "zoneImportFile.button.startImport"
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.step === "done"
        ? [
            _c(
              "div",
              { staticClass: "done-page" },
              [
                _c(
                  "el-card",
                  { staticClass: "done-card", attrs: { shadow: "never" } },
                  [
                    _c("div", { staticClass: "done-container" }, [
                      _c(
                        "span",
                        {
                          staticClass: "done-icon-wrap",
                          class: { "is-warning": !_vm.importResultFlag },
                        },
                        [
                          _c("i", {
                            class: [
                              _vm.importResultFlag
                                ? "el-icon-check"
                                : "el-icon-warning-outline",
                              "done-icon",
                            ],
                          }),
                        ]
                      ),
                      _c("div", { staticClass: "done-title" }, [
                        _vm._v(_vm._s(_vm.doneTitle)),
                      ]),
                      _c("div", { staticClass: "done-text" }, [
                        _vm._v(_vm._s(_vm.doneText)),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "el-card",
                  {
                    staticClass: "import-stats-card",
                    attrs: { shadow: "never" },
                  },
                  [
                    _c("div", { staticClass: "section-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("zoneImportFile.section.importStats"))
                      ),
                    ]),
                    _c("div", { staticClass: "import-stats-grid" }, [
                      _c(
                        "div",
                        { staticClass: "import-stat-item import-stat-total" },
                        [
                          _c("div", { staticClass: "import-stat-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("zoneImportFile.stats.totalProcessed")
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "import-stat-value" }, [
                            _vm._v(_vm._s(_vm.validateResult.total)),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "import-stat-item import-stat-success" },
                        [
                          _c("div", { staticClass: "import-stat-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("zoneImportFile.stats.importSuccess")
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "import-stat-value" }, [
                            _vm._v(_vm._s(_vm.validateResult.passed)),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "import-stat-item import-stat-failed" },
                        [
                          _c("div", { staticClass: "import-stat-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("zoneImportFile.stats.importFailed")
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "import-stat-value" }, [
                            _vm._v(_vm._s(_vm.validateResult.failed)),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm.importResponseErrorRows.length > 0
                  ? _c(
                      "el-card",
                      {
                        staticClass: "error-detail-card",
                        attrs: { shadow: "never" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "error-detail-header" },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("zoneImportFile.section.errorDetails")
                                )
                              ),
                            ]),
                            _vm.canDownloadErrorReport
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      plain: "",
                                      size: "small",
                                      icon: "el-icon-download",
                                    },
                                    on: { click: _vm.downloadErrorReport },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "zoneImportFile.button.exportErrorData"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-table",
                          {
                            staticClass: "error-detail-table",
                            attrs: {
                              data: _vm.importResponseErrorRows,
                              border: "",
                              size: "small",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "rowNumber",
                                label: _vm.$t("zoneImportFile.table.rowNumber"),
                                width: "72",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "partitionType",
                                label: _vm.$t(
                                  "zoneImportFile.table.partitionType"
                                ),
                                "min-width": "90",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "country",
                                label: _vm.$t("zoneImportFile.table.country"),
                                "min-width": "90",
                              },
                            }),
                            _vm.showImportStateColumn
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "state",
                                    label: _vm.$t("zoneImportFile.table.state"),
                                    "min-width": "110",
                                  },
                                })
                              : _vm._e(),
                            _vm.showImportCityColumn
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "city",
                                    label: _vm.$t("zoneImportFile.table.city"),
                                    "min-width": "110",
                                  },
                                })
                              : _vm._e(),
                            _vm.showImportPostCodeColumn
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "startPostCode",
                                    label: _vm.$t(
                                      "zoneImportFile.table.startPostalCode"
                                    ),
                                    "min-width": "120",
                                  },
                                })
                              : _vm._e(),
                            _vm.showImportPostCodeColumn
                              ? _c("el-table-column", {
                                  attrs: {
                                    prop: "endPostCode",
                                    label: _vm.$t(
                                      "zoneImportFile.table.endPostalCode"
                                    ),
                                    "min-width": "120",
                                  },
                                })
                              : _vm._e(),
                            _c("el-table-column", {
                              attrs: {
                                prop: "zone",
                                label: _vm.$t("zoneImportFile.table.zone"),
                                "min-width": "90",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "error",
                                label: _vm.$t(
                                  "zoneImportFile.table.errorReason"
                                ),
                                "min-width": "220",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "error-reason" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatImportError(row.error)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                642743436
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "action-footer done-footer" },
                  [
                    _c("el-button", { on: { click: _vm.reUpload } }, [
                      _vm._v(_vm._s(_vm.$t("zoneImportFile.button.reUpload"))),
                    ]),
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.goBack } },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("zoneImportFile.button.backToZoneList"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "info-badge" }, [
      _c("i", { staticClass: "el-icon-info" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-icon-box" }, [
      _c("span", { staticClass: "file-ext" }, [_vm._v("X")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }